import apiClient from "./config";
import { TASK_ENDPOINTS } from "./endpoints";

export const getTaskList = () => apiClient.get(TASK_ENDPOINTS.GET_TASK_LIST);
export const addNewTask = (task) => apiClient.create(TASK_ENDPOINTS.ADD_NEW_TASK, task);
export const updateTask = (task) => apiClient.update(TASK_ENDPOINTS.UPDATE_TASK + '/' + task._id, task);
export const deleteTask = (task) => apiClient.delete(TASK_ENDPOINTS.DELETE_TASK + '/' + task);

// Kanban Board
export const getTasks = () => apiClient.get(TASK_ENDPOINTS.GET_TASKS);
export const addNewTasks = (card) => apiClient.create(TASK_ENDPOINTS.ADD_TASKS, card);
export const updateTasks = (card) => apiClient.put(TASK_ENDPOINTS.UPDATE_TASKS, card);
export const deleteTasks = (card) => apiClient.delete(TASK_ENDPOINTS.DELETE_TASKS, { headers: { card } });

